// extracted by mini-css-extract-plugin
module.exports = {"tableRowActionsMobile":"MailingListTable_tableRowActionsMobile_1kqVL","tableRowActions":"MailingListTable_tableRowActions_38Qnu"};